import type { PostgrestSingleResponse } from "@supabase/postgrest-js";
import { useSupabaseCallback } from "../../../server/supabase/hooks";
import type { SupabaseCallback } from "../../../server/supabase/hooks/use-supabase-callback";
import { toISO8601 } from "../../../utils/iso8601";
import type { UUID } from "../../../utils/uuid";
import type { Asset } from "../server/digital-asset-service";
import { SupabaseDigitalAssetService, toAsset } from "../server/digital-asset-service";

export const useDeleteAssetCallback = (): SupabaseCallback<
  [UUID],
  PostgrestSingleResponse<Asset>
> => {
  return useSupabaseCallback(async ({ supabase }, assetId: UUID) => {
    const response = await new SupabaseDigitalAssetService(supabase).update(assetId, {
      deleted_at: toISO8601(new Date()),
    });
    if (response.error || !response.data) return response;
    return {
      ...response,
      data: toAsset(response.data),
    };
  }, []);
};
